/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer, breakpoints } from '@coursera/cds-core';

type Props = {
  courseCard: JSX.Element;
  navigation: JSX.Element;
  notification?: JSX.Element;
  showBackground?: boolean;
  title?: JSX.Element;
};

const styles = {
  noBackground: css`
    padding: var(--cds-spacing-300) 0;
  `,
  background: css`
    padding: var(--cds-spacing-300) 0;
    background-color: var(--cds-color-neutral-disabled-weak);
    margin-bottom: var(--cds-spacing-400);
    ${breakpoints.down('sm')} {
      background-color: initial;
      margin-bottom: 0;
    }
  `,
  wrapper: css`
    display: flex;
    flex-wrap: nowrap;
    column-gap: var(--cds-spacing-400);
    margin-bottom: var(--cds-spacing-200);
    ${breakpoints.down('sm')} {
      flex-wrap: wrap;
      gap: var(--cds-spacing-150);
      margin-bottom: 0;
    }
  `,
};

/**
 * @description This module is used to display the "Continue Learning" section on the learner home page.
 */
const ContinueLearningModule = ({ title, courseCard, navigation, notification, showBackground }: Props) => {
  return (
    <div css={showBackground ? styles.background : styles.noBackground}>
      <PageGridContainer className="continue-learning-module">
        <Grid item xs={12}>
          {title}
          {notification}
          <Grid container css={styles.wrapper}>
            {courseCard}
            {navigation}
          </Grid>
        </Grid>
      </PageGridContainer>
    </div>
  );
};
export default ContinueLearningModule;
